import React from "react";
import { useState, useEffect, Suspense } from "react";
import { getAbout } from "../requests";
import { AboutInterface } from "../types";
import { CircularProgress } from "@material-ui/core";

const LandingPageCard = React.lazy(
  () => import("../components/LandingPageCard")
);
const ToolkitButtonCard = React.lazy(
  () => import("../components/ToolkitButtonCard")
);

function Home() {
  const [aboutus, setAbout] = useState<AboutInterface>({
    project_title: "",
    description: "",
    aims_title: "",
    aims: "",
  });

  useEffect(() => {
    getAbout().then(() => {
      let localData = localStorage.getItem("about");
      if (localData) {
        const data: AboutInterface = JSON.parse(localData || "{}");
        setAbout({
          project_title: data.project_title,
          description: data.description,
          aims_title: data.aims_title,
          aims: data.aims,
        });
      }
    });
  }, []);

  return (
    <div>
      <Suspense fallback={<CircularProgress />}>
        <LandingPageCard
          title={aboutus.project_title}
          description={`This toolkit is designed to help with digitalization and online service delivery
           in the charity and voluntary sector. It provides insight into the solutions and actions
          needed to overcome the challenges of moving services online in the charity and voluntary sector.
          The toolkit aims to help the sector benefit from the advantages of digitalization and online
          delivery whilst responding to the multiplex needs of their often vulnerable service 
          users by providing a human-centred and empathetic online services.
        `}
          buttonTitle={`Start Toolkit`}
        />
        <ToolkitButtonCard />
      </Suspense>
    </div>
  );
}

export default Home;
